import { inject, Injectable } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { UtilsService } from 'src/app/services/utils.service';

@Injectable({ providedIn: 'root' })
export abstract class RoleGuard {
  role: string[];
  departmentCategory?: string;

  protected permissions = inject(PermissionsService);
  protected utils = inject(UtilsService);

  async canActivate(): Promise<boolean> {
    if (this.departmentCategory) {
      return this.isDepartmentCategory() || (await this.isDepartment());
    } else return await this.isDepartment();
  }

  protected async isDepartment(it: number = 0): Promise<boolean> {
    if (it > 5) return false;
    else {
      let isDepartment: boolean = false;
      const roles: string[] = ['direction', ...this.role];
      roles.forEach(role => {
        isDepartment = isDepartment || this.permissions.isDepartment(role);
      });

      if (!isDepartment) {
        await this.utils.sleep(200);
        return this.isDepartment(it + 1);
      } else return true;
    }
  }

  protected isDepartmentCategory(): boolean {
    return this.permissions.isDepartmentCategory(this.departmentCategory ?? '');
  }
}
